
export const USER_CENTER = {

  /* 收藏记录tab 默认all, picture 图片, package 图片包, topic 专题*/
  COLLECT_RECORD :{
    TAB: [
      /*{
        id: 0,
        label: '全部',
        iconClass:'all',
        mode: 'all'
      },*/
      {
        id: 1,
        label: '图片',
        iconClass:'pic',
        mode: 'picture'
      },
      {
        id: 2,
        label: '图片包',
        iconClass:'package',
        mode: 'package'
      },
      {
        id: 3,
        label: '专题',
        iconClass:'topic',
        mode: 'topic'
      },
    ]
  }
}
